var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.59453 5.59609V12.7961H11.9945V5.59609H3.59453ZM3.59453 4.39609H11.9945V3.19609H3.59453V4.39609ZM12.5945 13.9961H2.99453C2.8354 13.9961 2.68279 13.9329 2.57027 13.8204C2.45775 13.7078 2.39453 13.5552 2.39453 13.3961V2.59609C2.39453 2.43696 2.45775 2.28435 2.57027 2.17183C2.68279 2.05931 2.8354 1.99609 2.99453 1.99609H12.5945C12.7537 1.99609 12.9063 2.05931 13.0188 2.17183C13.1313 2.28435 13.1945 2.43696 13.1945 2.59609V13.3961C13.1945 13.5552 13.1313 13.7078 13.0188 13.8204C12.9063 13.9329 12.7537 13.9961 12.5945 13.9961ZM4.79453 6.79609H7.19453V9.19609H4.79453V6.79609ZM4.79453 10.3961H10.7945V11.5961H4.79453V10.3961ZM8.39453 7.39609H10.7945V8.59609H8.39453V7.39609Z",
    fill: "#6B6B6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/Resume_icon.32fb1168dbfafacc6ae79e93cd8fb655.svg";
export { ForwardRef as ReactComponent };